import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165')
];

export const server_loads = [];

export const dictionary = {
		"/[[lang=locale]]/(index-page)": [42,[2],[3]],
		"/[[lang=locale]]/(non-auth)/accept-invite": [158,[2,39],[3]],
		"/[[lang=locale]]/(need-unauth)/account-recovery": [145,[2,36],[3]],
		"/[[lang=locale]]/error": [165,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign": [159,[2,39,40],[3]],
		"/[[lang=locale]]/(non-auth)/esign/auth": [160,[2,39,40],[3]],
		"/[[lang=locale]]/(non-auth)/esign/exit": [161,[2,39,40],[3]],
		"/[[lang=locale]]/(non-auth)/esign/exit/[token]": [162,[2,39,40],[3]],
		"/[[lang=locale]]/(non-auth)/like-reload": [163,[2,39],[3]],
		"/[[lang=locale]]/(non-auth)/login/sso/[ssoPartnerType]": [164,[2,39],[3]],
		"/[[lang=locale]]/(need-auth)/logout": [122,[2,4],[3]],
		"/[[lang=locale]]/(need-unauth)/reset-password-from-email": [146,[2,36],[3]],
		"/[[lang=locale]]/(need-auth)/reset-password-or-postpone": [123,[2,4],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-in": [147,[2,36,37],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct": [148,[2,36,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/complete": [149,[2,36,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/email-input": [150,[2,36,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/set-password": [151,[2,36,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/terms": [152,[2,36,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/user-name": [153,[2,36,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/verify-code": [154,[2,36,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/invite": [155,[2,36],[3]],
		"/[[lang=locale]]/(need-auth)/sso-sign-in-callback": [124,[2,4],[3]],
		"/[[lang=locale]]/(need-unauth)/sso-sign-up-callback": [156,[2,36],[3]],
		"/[[lang=locale]]/(need-unauth)/super-admin": [157,[2,36],[3]],
		"/[[lang=locale]]/(need-auth)/su": [125,[2,4,31],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users": [126,[2,4,31,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users/all-users": [127,[2,4,31,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users/expert-applicants": [128,[2,4,31,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users/form": [129,[2,4,31,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/contract-template": [130,[2,4,31],[3]],
		"/[[lang=locale]]/(need-auth)/su/contract-template/[templateId]": [131,[2,4,31],[3]],
		"/[[lang=locale]]/(need-auth)/su/super-users": [132,[2,4,31],[3]],
		"/[[lang=locale]]/(need-auth)/su/terms": [133,[2,4,31],[3]],
		"/[[lang=locale]]/(need-auth)/su/terms/[id]": [134,[2,4,31],[3]],
		"/[[lang=locale]]/(need-auth)/su/workflow-management": [135,[2,4,31,33],[3]],
		"/[[lang=locale]]/(need-auth)/su/workflow-management/[id]": [136,[2,4,31,33],[3]],
		"/[[lang=locale]]/(need-auth)/su/workspaces": [137,[2,4,31,34],[3]],
		"/[[lang=locale]]/(need-auth)/su/workspaces/form": [139,[2,4,31,34],[3]],
		"/[[lang=locale]]/(need-auth)/su/workspaces/[id]": [138,[2,4,31,34],[3]],
		"/[[lang=locale]]/(need-auth)/workspace": [140,[2,4,35],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create": [141,[2,4,35],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create/company-info": [142,[2,4,35],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create/complete": [143,[2,4,35],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create/select-plan": [144,[2,4,35],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]": [43,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/account/(with-sidebar)": [44,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/account/(with-sidebar)/language": [45,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/account/(with-sidebar)/profile": [46,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)": [47,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/edit-permissions": [48,[2,4,5,7,8,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice": [49,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice/form": [51,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice/form/[id]": [52,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice/[id]": [50,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/payment": [53,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/seal-management": [54,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/user-list": [55,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/user-list/[tab]": [56,[2,4,5,7,8,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-info": [57,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview": [58,[2,4,5,7,8,11],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview/divisions": [59,[2,4,5,7,8,11],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview/positions": [60,[2,4,5,7,8,11],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview/titles": [61,[2,4,5,7,8,11],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)": [62,[2,4,5,12,13],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/agent": [63,[2,4,5,12,13],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/chat": [64,[2,4,5,12,13],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/db-management": [65,[2,4,5,12,13],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/legislation": [69,[2,4,5,12],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/review": [66,[2,4,5,12,13],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/search": [67,[2,4,5,12,13,14],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/workflow": [68,[2,4,5,12,13],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)": [70,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/ai-contracts": [71,[2,4,5,15,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/ai-contracts/drafts": [72,[2,4,5,15,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/approval": [81,[2,4,5,15,16,20],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/approval/draft/[contractId]": [95,[2,4,5,15,23],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/approval/[approvalId]": [94,[2,4,5,15,23],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/assignment": [82,[2,4,5,15,16,21],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/conhub": [96,[2,4,5,15],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/conhub/[contractId]": [97,[2,4,5,15],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/contracts": [73,[2,4,5,15,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/contracts/drafts": [74,[2,4,5,15,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/core-home": [75,[2,4,5,15,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/counterparty-list-management": [83,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/home": [84,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/my-request": [85,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(new-contract)/new-contract-standard": [79,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(new-contract)/new-contract-upload": [80,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/repository": [86,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/repository/contract-extract": [98,[2,4,5,15],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/repository/detail/[id]": [99,[2,4,5,15],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/repository/drafts": [76,[2,4,5,15,16,17,18],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/repository/reexecute-copy": [100,[2,4,5,15],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/seal-documents": [87,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/seal-management": [88,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/signing": [77,[2,4,5,15,16,17,19],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/signing/drafts": [78,[2,4,5,15,16,17,19],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/template": [89,[2,4,5,15,16,22],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/template/custom": [90,[2,4,5,15,16,22],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/template/global": [91,[2,4,5,15,16,22],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/template/[templateId]": [101,[2,4,5,15],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/upload-signed-bulk": [93,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/upload-signed": [92,[2,4,5,15,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)": [102,[2,4,5,24],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/advisory": [103,[2,4,5,24,25],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/advisory/new": [105,[2,4,5,24,25,27],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/advisory/[id]": [104,[2,4,5,24,25,26],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/assignment": [106,[2,4,5,24],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/home": [107,[2,4,5,24],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/lawfirm": [108,[2,4,5,24,28],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/lawfirm/[id]": [109,[2,4,5,24,28],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations": [110,[2,4,5,24],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/new": [120,[2,4,5,24],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]": [111,[2,4,5,24,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/commentsAndRecords": [114,[2,4,5,24,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/email": [115,[2,4,5,24,29,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/email/[emailId]": [116,[2,4,5,24,29,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/expenseManagement": [117,[2,4,5,24,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/fileManagement": [118,[2,4,5,24,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/(supreme-court-connectable)/lawsuitGeneralContents": [112,[2,4,5,24,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/(supreme-court-connectable)/lawsuitProgressedContents": [113,[2,4,5,24,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/litigationRegistrationInformation": [119,[2,4,5,24,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/subscription-expired": [121,[2,4,5],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';